// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__13zO5","inner":"Footer_inner__3Suqx"};